// 간단한 성능 최적화 플러그인

export default function ({ app }) {
  // 클라이언트에서만 실행
  if (process.client) {
    // 전역 성능 유틸리티 추가
    app.$performance = {
      // 성능 마크 생성
      mark (name) {
        if (window.performance?.mark) {
          try {
            window.performance.mark(name)
          } catch (e) {
            // 무시
          }
        }
      },

      // 성능 측정
      measure (name, startMark, endMark) {
        if (window.performance?.measure) {
          try {
            window.performance.measure(name, startMark, endMark)
            const measure = window.performance.getEntriesByName(name)[0]
            return measure ? measure.duration : 0
          } catch (e) {
            return 0
          }
        }
        return 0
      }
    }

    // 기본적인 메모리 정리
    window.addEventListener('beforeunload', () => {
      // 간단한 정리 작업
      if (window.gc && process.env.NODE_ENV === 'development') {
        try {
          window.gc()
        } catch (e) {
          // 무시
        }
      }
    })
  }
}
